import React from 'react'
import { 
  Users, 
  UserPlus, 
  Award, 
  Calendar, 
  BarChart3, 
  AlertCircle, 
  BookOpen 
} from 'lucide-react'

interface QuickActionsProps {
  userRole: string
}

export function QuickActions({ userRole }: QuickActionsProps) {
  const actions = {
    admin: [
      { name: 'Equipe', href: '/employees', icon: Users },
      { name: 'Novo Colaborador', href: '/employees/new', icon: UserPlus },
      { name: 'Processo Seletivo', href: '/recruitment/new', icon: Users },
      { name: 'Novo Treinamento', href: '/training/new', icon: BookOpen },
      { name: 'Relatórios', href: '/reports', icon: BarChart3 }
    ],
    manager: [
      { name: 'Equipe', href: '/employees', icon: Users },
      { name: 'Avaliar Colaborador', href: '/performance/new', icon: Award },
      // HIDDEN: { name: 'Agendar 1:1', href: '/meetings/schedule', icon: Calendar },
      { name: 'Relatórios', href: '/reports', icon: BarChart3 }
    ],
    employee: [
      { name: 'Meu Perfil', href: '/profile', icon: Users },
      { name: 'Treinamentos', href: '/training', icon: Award },
      { name: 'Solicitar Férias', href: '/vacation/request', icon: Calendar },
      { name: 'Documentos', href: '/documents', icon: AlertCircle }
    ]
  }

  const currentActions = actions[userRole as keyof typeof actions] || []

  return (
    <div className="card">
      <h3 className="font-display text-base sm:text-lg font-semibold text-white mb-6 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">
        Ações Rápidas
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {currentActions.map((action) => {
          const Icon = action.icon
          return (
            <a
              key={action.name}
              href={action.href}
              className="card-interactive group flex items-center p-4 transition-all duration-200"
            >
              <div className="p-2 rounded-monumenta bg-brand-primary/10 group-hover:bg-brand-primary/20 transition-colors duration-200 mr-3">
                <Icon className="text-brand-primary group-hover:scale-110 transition-transform duration-200" size={20} />
              </div>
              <span className="text-sm text-gray-300 group-hover:text-white font-body group-hover:font-medium transition-all duration-200">
                {action.name}
              </span>
            </a>
          )
        })}
      </div>
    </div>
  )
}